import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './elements/App';
import reportWebVitals from './reportWebVitals';
import Info from "./elements/Info"
import Catalogo from "./elements/Catalogo"
import Contattaci from "./elements/Contattaci"
import Prodotti from "./elements/Prodotti"
import Privacy from "./elements/Privacy"
import Cover from "./elements/prodotti/telefono/Cover-vetriProtettivi"
import CaricaBatterie from "./elements/prodotti/telefono/CaricaBatterie-adattatori"
import Usb from "./elements/prodotti/telefono/Usb-schedeSD"
import Cuffie from "./elements/prodotti/telefono/Cuffie-powerbank"
import Orecchini from "./elements/prodotti/bigiotteria/Orecchini"
import Anelli from "./elements/prodotti/bigiotteria/Anelli"
import Braccialetti from "./elements/prodotti/bigiotteria/Braccialetti"
import Collane from "./elements/prodotti/bigiotteria/Collane"
import PopUpImg from "./elements/PopUpImg"

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App/>,
  },
  {
    path: "informazioni",
    element: <Info/>,
  },
  {
    path: "prodotti",
    element: <Prodotti/>,
  },
  {
    path: "catalogo",
    element: <Catalogo/>,
  },
  {
    path: "contattaci",
    element: <Contattaci/>,
  },
  {
    path: "privacy",
    element: <Privacy/>,
  },
  {
    path: "prodotti/cover-vetriProtettivi",
    element: <Cover/>,
  },
  {
    path: "prodotti/caricaBatterie-adattatori",
    element: <CaricaBatterie/>,
  },
  {
    path: "prodotti/Usb-schedeSD",
    element: <Usb/>,
  },
  {
    path: "prodotti/cuffie-powerbank",
    element: <Cuffie/>,
  },
  {
    path: "prodotti/orecchini",
    element: <Orecchini/>,
  },
  {
    path: "prodotti/anelli",
    element: <Anelli/>,
  },
  {
    path: "prodotti/braccialetti",
    element: <Braccialetti/>,
  },
  {
    path: "prodotti/collane",
    element: <Collane/>,
  },
  {
    path: "prodotti/:imgId",
    element: <PopUpImg/>,
  }

]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 
  <RouterProvider router={router} />
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();